const REACT_APP_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const POSITIONS_API_URL = REACT_APP_API_URL + '/api/positions/';
export const PREVIOUS_POSITIONS_API_URL = REACT_APP_API_URL + '/api/previous-positions/';
export const PREVIOUS_POSITION_API_URL = REACT_APP_API_URL + '/api/previous-position/';
export const TRADES_API_URL = REACT_APP_API_URL + '/api/trades/';
export const ACCOUNT_INFO_API_URL = REACT_APP_API_URL + '/api/account-info/';
export const ACCOUNT_CASHFLOWS_API_URL = REACT_APP_API_URL + '/api/account-cashflows/';
export const GET_STRATEGIES_API_URL = REACT_APP_API_URL + '/api/get-strategies/';
export const GET_CURRENCIES_API_URL = REACT_APP_API_URL + '/api/get-currencies/';
export const PUSH_PUBLIC_KEY_API_URL = REACT_APP_API_URL + '/api/push/public-key/';
export const PUSH_SUBSCRIPTIONS_API_URL = REACT_APP_API_URL + '/api/push/subscriptions/';
export const PUSH_PREFERENCES_API_URL = REACT_APP_API_URL + '/api/push/preferences/';
export const STATS_DISPLAY_PREFERENCES_API_URL = REACT_APP_API_URL + '/api/stats-display/preferences/';
export const API_URL = REACT_APP_API_URL + '/api/';
